// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Coming Soon Page Styles */
.coming-soon-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.background-canvas {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}

.coming-soon-content {
  text-align: center;
  z-index: 1;
  max-width: 800px;
  padding: 2rem;
  position: relative;
}

/* AI Brain Animation */
.ai-brain-container {
  margin-bottom: 3rem;
  display: flex;
  justify-content: center;
}

.ai-brain {
  position: relative;
  width: 200px;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.brain-node {
  position: absolute;
  width: 12px;
  height: 12px;
  background: linear-gradient(45deg, #49c1f4, #3b82f6);
  border-radius: 50%;
  animation: pulse 2s ease-in-out infinite;
  box-shadow: 0 0 20px rgba(73, 193, 244, 0.5);
}

.brain-node:nth-child(1) { top: 20px; left: 50px; animation-delay: 0s; }
.brain-node:nth-child(2) { top: 20px; right: 50px; animation-delay: 0.2s; }
.brain-node:nth-child(3) { top: 60px; left: 30px; animation-delay: 0.4s; }
.brain-node:nth-child(4) { top: 60px; right: 30px; animation-delay: 0.6s; }
.brain-node:nth-child(5) { top: 100px; left: 50px; animation-delay: 0.8s; }
.brain-node:nth-child(6) { top: 100px; right: 50px; animation-delay: 1s; }
.brain-node:nth-child(7) { bottom: 60px; left: 30px; animation-delay: 1.2s; }
.brain-node:nth-child(8) { bottom: 60px; right: 30px; animation-delay: 1.4s; }
.brain-node:nth-child(9) { bottom: 20px; left: 50px; animation-delay: 1.6s; }
.brain-node:nth-child(10) { bottom: 20px; right: 50px; animation-delay: 1.8s; }
.brain-node:nth-child(11) { top: 50%; left: 20px; animation-delay: 2s; }
.brain-node:nth-child(12) { top: 50%; right: 20px; animation-delay: 2.2s; }

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
    opacity: 0.8;
  }
  50% {
    transform: scale(1.2);
    opacity: 1;
  }
}

.brain-connections {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}

.connection-line {
  fill: none;
  stroke: rgba(73, 193, 244, 0.3);
  stroke-width: 1;
  stroke-dasharray: 5, 5;
  animation: dash 3s linear infinite;
}

@keyframes dash {
  to {
    stroke-dashoffset: -10;
  }
}

/* Text Content */
.text-content {
  margin-bottom: 3rem;
}

.coming-soon-title {
  font-size: 4rem;
  font-weight: 700;
  margin-bottom: 1rem;
  background: linear-gradient(135deg, #49c1f4, #3b82f6, #8b5cf6);
  background-size: 200% 200%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  animation: gradientShift 3s ease-in-out infinite;
}

@keyframes gradientShift {
  0%, 100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}

.title-word {
  display: inline-block;
  animation: color-animation 4s linear infinite;
}

.title-word-1 {
  --color-1: #49c1f4;
  --color-2: #3b82f6;
  --color-3: #8b5cf6;
}

.title-word-2 {
  --color-1: #3b82f6;
  --color-2: #8b5cf6;
  --color-3: #49c1f4;
}

@keyframes color-animation {
  0%    {color: var(--color-1)}
  32%   {color: var(--color-1)}
  33%   {color: var(--color-2)}
  65%   {color: var(--color-2)}
  66%   {color: var(--color-3)}
  99%   {color: var(--color-3)}
  100%  {color: var(--color-1)}
}

.coming-soon-subtitle {
  font-size: 1.5rem;
  color: #94a3b8;
  margin-bottom: 3rem;
  font-weight: 300;
  animation: fadeInUp 1s ease-out 0.5s both;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* AI Features */
.ai-features {
  display: flex;
  justify-content: center;
  gap: 2rem;
  margin-bottom: 3rem;
  flex-wrap: wrap;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  color: #e2e8f0;
  font-size: 1rem;
  animation: fadeInUp 1s ease-out 1s both;
}

.feature-item:nth-child(2) {
  animation-delay: 1.2s;
}

.feature-item:nth-child(3) {
  animation-delay: 1.4s;
}

.feature-icon {
  position: relative;
  width: 20px;
  height: 20px;
}

.pulse-dot {
  width: 8px;
  height: 8px;
  background: #49c1f4;
  border-radius: 50%;
  animation: pulseDot 2s ease-in-out infinite;
}

@keyframes pulseDot {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.5);
    opacity: 0.7;
  }
}

/* Progress Indicator */
.progress-indicator {
  animation: fadeInUp 1s ease-out 1.6s both;
}

.progress-bar {
  width: 300px;
  height: 4px;
  background: rgba(73, 193, 244, 0.2);
  border-radius: 2px;
  margin: 0 auto 1rem;
  overflow: hidden;
  position: relative;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #49c1f4, #3b82f6);
  border-radius: 2px;
  animation: progressFill 3s ease-in-out infinite;
  position: relative;
}

.progress-fill::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  animation: shimmer 2s ease-in-out infinite;
}

@keyframes progressFill {
  0%, 100% {
    width: 30%;
  }
  50% {
    width: 70%;
  }
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

.progress-text {
  color: #94a3b8;
  font-size: 0.9rem;
  font-weight: 300;
}

/* Floating Elements */
.floating-elements {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: -1;
}

.floating-element {
  position: absolute;
  font-size: 2rem;
  opacity: 0.3;
  animation: float 6s ease-in-out infinite;
}

.element-1 {
  top: 10%;
  left: 10%;
  animation-delay: 0s;
}

.element-2 {
  top: 20%;
  right: 15%;
  animation-delay: 1s;
}

.element-3 {
  top: 60%;
  left: 5%;
  animation-delay: 2s;
}

.element-4 {
  top: 70%;
  right: 10%;
  animation-delay: 3s;
}

.element-5 {
  bottom: 20%;
  left: 20%;
  animation-delay: 4s;
}

.element-6 {
  bottom: 30%;
  right: 25%;
  animation-delay: 5s;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0px) rotate(0deg);
  }
  33% {
    transform: translateY(-20px) rotate(5deg);
  }
  66% {
    transform: translateY(10px) rotate(-5deg);
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .coming-soon-content {
    padding: 1rem;
  }

  .coming-soon-title {
    font-size: 2.5rem;
  }

  .coming-soon-subtitle {
    font-size: 1.2rem;
  }

  .ai-features {
    flex-direction: column;
    gap: 1rem;
  }

  .progress-bar {
    width: 250px;
  }

  .ai-brain {
    width: 150px;
    height: 150px;
  }

  .brain-node {
    width: 8px;
    height: 8px;
  }

  .floating-element {
    font-size: 1.5rem;
  }
}

@media (max-width: 480px) {
  .coming-soon-title {
    font-size: 2rem;
  }

  .coming-soon-subtitle {
    font-size: 1rem;
  }

  .progress-bar {
    width: 200px;
  }

  .ai-brain {
    width: 120px;
    height: 120px;
  }

  .brain-node {
    width: 6px;
    height: 6px;
  }
}

/* Additional hover effects */
.feature-item:hover .pulse-dot {
  animation: pulseDot 0.5s ease-in-out infinite;
}

.progress-bar:hover .progress-fill {
  animation: progressFill 1s ease-in-out infinite;
}

/* Smooth transitions */
* {
  transition: all 0.3s ease;
}

/* Loading animation for brain nodes */
.brain-node::before {
  content: '';
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  border: 2px solid rgba(73, 193, 244, 0.3);
  border-radius: 50%;
  animation: ripple 2s ease-out infinite;
}

@keyframes ripple {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(2);
    opacity: 0;
  }
} `, "",{"version":3,"sources":["webpack://./src/Components/ComingSoon.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,uFAAuF;AACzF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,wCAAwC;EACxC,4CAA4C;AAC9C;;AAEA,2BAA2B,SAAS,EAAE,UAAU,EAAE,mBAAmB,EAAE;AACvE,2BAA2B,SAAS,EAAE,WAAW,EAAE,qBAAqB,EAAE;AAC1E,2BAA2B,SAAS,EAAE,UAAU,EAAE,qBAAqB,EAAE;AACzE,2BAA2B,SAAS,EAAE,WAAW,EAAE,qBAAqB,EAAE;AAC1E,2BAA2B,UAAU,EAAE,UAAU,EAAE,qBAAqB,EAAE;AAC1E,2BAA2B,UAAU,EAAE,WAAW,EAAE,mBAAmB,EAAE;AACzE,2BAA2B,YAAY,EAAE,UAAU,EAAE,qBAAqB,EAAE;AAC5E,2BAA2B,YAAY,EAAE,WAAW,EAAE,qBAAqB,EAAE;AAC7E,2BAA2B,YAAY,EAAE,UAAU,EAAE,qBAAqB,EAAE;AAC5E,4BAA4B,YAAY,EAAE,WAAW,EAAE,qBAAqB,EAAE;AAC9E,4BAA4B,QAAQ,EAAE,UAAU,EAAE,mBAAmB,EAAE;AACvE,4BAA4B,QAAQ,EAAE,WAAW,EAAE,qBAAqB,EAAE;;AAE1E;EACE;IACE,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,UAAU;EACV,+BAA+B;EAC/B,eAAe;EACf,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,8DAA8D;EAC9D,0BAA0B;EAC1B,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,OAAO,qBAAqB;EAC5B,OAAO,qBAAqB;EAC5B,OAAO,qBAAqB;EAC5B,OAAO,qBAAqB;EAC5B,OAAO,qBAAqB;EAC5B,OAAO,qBAAqB;EAC5B,OAAO,qBAAqB;AAC9B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,qBAAqB;IACrB,YAAY;EACd;AACF;;AAEA,uBAAuB;AACvB;EACE,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mCAAmC;EACnC,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,+CAA+C;EAC/C,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sFAAsF;EACtF,0CAA0C;AAC5C;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,QAAQ;EACR,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE;IACE,uCAAuC;EACzC;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,yCAAyC;EAC3C;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,UAAU;IACV,WAAW;EACb;AACF;;AAEA,6BAA6B;AAC7B;EACE,6CAA6C;AAC/C;;AAEA;EACE,+CAA+C;AACjD;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;AAC3B;;AAEA,sCAAsC;AACtC;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF","sourcesContent":["/* Coming Soon Page Styles */\n.coming-soon-container {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  overflow: hidden;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n}\n\n.background-canvas {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: -1;\n}\n\n.coming-soon-content {\n  text-align: center;\n  z-index: 1;\n  max-width: 800px;\n  padding: 2rem;\n  position: relative;\n}\n\n/* AI Brain Animation */\n.ai-brain-container {\n  margin-bottom: 3rem;\n  display: flex;\n  justify-content: center;\n}\n\n.ai-brain {\n  position: relative;\n  width: 200px;\n  height: 200px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.brain-node {\n  position: absolute;\n  width: 12px;\n  height: 12px;\n  background: linear-gradient(45deg, #49c1f4, #3b82f6);\n  border-radius: 50%;\n  animation: pulse 2s ease-in-out infinite;\n  box-shadow: 0 0 20px rgba(73, 193, 244, 0.5);\n}\n\n.brain-node:nth-child(1) { top: 20px; left: 50px; animation-delay: 0s; }\n.brain-node:nth-child(2) { top: 20px; right: 50px; animation-delay: 0.2s; }\n.brain-node:nth-child(3) { top: 60px; left: 30px; animation-delay: 0.4s; }\n.brain-node:nth-child(4) { top: 60px; right: 30px; animation-delay: 0.6s; }\n.brain-node:nth-child(5) { top: 100px; left: 50px; animation-delay: 0.8s; }\n.brain-node:nth-child(6) { top: 100px; right: 50px; animation-delay: 1s; }\n.brain-node:nth-child(7) { bottom: 60px; left: 30px; animation-delay: 1.2s; }\n.brain-node:nth-child(8) { bottom: 60px; right: 30px; animation-delay: 1.4s; }\n.brain-node:nth-child(9) { bottom: 20px; left: 50px; animation-delay: 1.6s; }\n.brain-node:nth-child(10) { bottom: 20px; right: 50px; animation-delay: 1.8s; }\n.brain-node:nth-child(11) { top: 50%; left: 20px; animation-delay: 2s; }\n.brain-node:nth-child(12) { top: 50%; right: 20px; animation-delay: 2.2s; }\n\n@keyframes pulse {\n  0%, 100% {\n    transform: scale(1);\n    opacity: 0.8;\n  }\n  50% {\n    transform: scale(1.2);\n    opacity: 1;\n  }\n}\n\n.brain-connections {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: -1;\n}\n\n.connection-line {\n  fill: none;\n  stroke: rgba(73, 193, 244, 0.3);\n  stroke-width: 1;\n  stroke-dasharray: 5, 5;\n  animation: dash 3s linear infinite;\n}\n\n@keyframes dash {\n  to {\n    stroke-dashoffset: -10;\n  }\n}\n\n/* Text Content */\n.text-content {\n  margin-bottom: 3rem;\n}\n\n.coming-soon-title {\n  font-size: 4rem;\n  font-weight: 700;\n  margin-bottom: 1rem;\n  background: linear-gradient(135deg, #49c1f4, #3b82f6, #8b5cf6);\n  background-size: 200% 200%;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  animation: gradientShift 3s ease-in-out infinite;\n}\n\n@keyframes gradientShift {\n  0%, 100% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n}\n\n.title-word {\n  display: inline-block;\n  animation: color-animation 4s linear infinite;\n}\n\n.title-word-1 {\n  --color-1: #49c1f4;\n  --color-2: #3b82f6;\n  --color-3: #8b5cf6;\n}\n\n.title-word-2 {\n  --color-1: #3b82f6;\n  --color-2: #8b5cf6;\n  --color-3: #49c1f4;\n}\n\n@keyframes color-animation {\n  0%    {color: var(--color-1)}\n  32%   {color: var(--color-1)}\n  33%   {color: var(--color-2)}\n  65%   {color: var(--color-2)}\n  66%   {color: var(--color-3)}\n  99%   {color: var(--color-3)}\n  100%  {color: var(--color-1)}\n}\n\n.coming-soon-subtitle {\n  font-size: 1.5rem;\n  color: #94a3b8;\n  margin-bottom: 3rem;\n  font-weight: 300;\n  animation: fadeInUp 1s ease-out 0.5s both;\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* AI Features */\n.ai-features {\n  display: flex;\n  justify-content: center;\n  gap: 2rem;\n  margin-bottom: 3rem;\n  flex-wrap: wrap;\n}\n\n.feature-item {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  color: #e2e8f0;\n  font-size: 1rem;\n  animation: fadeInUp 1s ease-out 1s both;\n}\n\n.feature-item:nth-child(2) {\n  animation-delay: 1.2s;\n}\n\n.feature-item:nth-child(3) {\n  animation-delay: 1.4s;\n}\n\n.feature-icon {\n  position: relative;\n  width: 20px;\n  height: 20px;\n}\n\n.pulse-dot {\n  width: 8px;\n  height: 8px;\n  background: #49c1f4;\n  border-radius: 50%;\n  animation: pulseDot 2s ease-in-out infinite;\n}\n\n@keyframes pulseDot {\n  0%, 100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  50% {\n    transform: scale(1.5);\n    opacity: 0.7;\n  }\n}\n\n/* Progress Indicator */\n.progress-indicator {\n  animation: fadeInUp 1s ease-out 1.6s both;\n}\n\n.progress-bar {\n  width: 300px;\n  height: 4px;\n  background: rgba(73, 193, 244, 0.2);\n  border-radius: 2px;\n  margin: 0 auto 1rem;\n  overflow: hidden;\n  position: relative;\n}\n\n.progress-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #49c1f4, #3b82f6);\n  border-radius: 2px;\n  animation: progressFill 3s ease-in-out infinite;\n  position: relative;\n}\n\n.progress-fill::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);\n  animation: shimmer 2s ease-in-out infinite;\n}\n\n@keyframes progressFill {\n  0%, 100% {\n    width: 30%;\n  }\n  50% {\n    width: 70%;\n  }\n}\n\n@keyframes shimmer {\n  0% {\n    transform: translateX(-100%);\n  }\n  100% {\n    transform: translateX(100%);\n  }\n}\n\n.progress-text {\n  color: #94a3b8;\n  font-size: 0.9rem;\n  font-weight: 300;\n}\n\n/* Floating Elements */\n.floating-elements {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  z-index: -1;\n}\n\n.floating-element {\n  position: absolute;\n  font-size: 2rem;\n  opacity: 0.3;\n  animation: float 6s ease-in-out infinite;\n}\n\n.element-1 {\n  top: 10%;\n  left: 10%;\n  animation-delay: 0s;\n}\n\n.element-2 {\n  top: 20%;\n  right: 15%;\n  animation-delay: 1s;\n}\n\n.element-3 {\n  top: 60%;\n  left: 5%;\n  animation-delay: 2s;\n}\n\n.element-4 {\n  top: 70%;\n  right: 10%;\n  animation-delay: 3s;\n}\n\n.element-5 {\n  bottom: 20%;\n  left: 20%;\n  animation-delay: 4s;\n}\n\n.element-6 {\n  bottom: 30%;\n  right: 25%;\n  animation-delay: 5s;\n}\n\n@keyframes float {\n  0%, 100% {\n    transform: translateY(0px) rotate(0deg);\n  }\n  33% {\n    transform: translateY(-20px) rotate(5deg);\n  }\n  66% {\n    transform: translateY(10px) rotate(-5deg);\n  }\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .coming-soon-content {\n    padding: 1rem;\n  }\n\n  .coming-soon-title {\n    font-size: 2.5rem;\n  }\n\n  .coming-soon-subtitle {\n    font-size: 1.2rem;\n  }\n\n  .ai-features {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .progress-bar {\n    width: 250px;\n  }\n\n  .ai-brain {\n    width: 150px;\n    height: 150px;\n  }\n\n  .brain-node {\n    width: 8px;\n    height: 8px;\n  }\n\n  .floating-element {\n    font-size: 1.5rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .coming-soon-title {\n    font-size: 2rem;\n  }\n\n  .coming-soon-subtitle {\n    font-size: 1rem;\n  }\n\n  .progress-bar {\n    width: 200px;\n  }\n\n  .ai-brain {\n    width: 120px;\n    height: 120px;\n  }\n\n  .brain-node {\n    width: 6px;\n    height: 6px;\n  }\n}\n\n/* Additional hover effects */\n.feature-item:hover .pulse-dot {\n  animation: pulseDot 0.5s ease-in-out infinite;\n}\n\n.progress-bar:hover .progress-fill {\n  animation: progressFill 1s ease-in-out infinite;\n}\n\n/* Smooth transitions */\n* {\n  transition: all 0.3s ease;\n}\n\n/* Loading animation for brain nodes */\n.brain-node::before {\n  content: '';\n  position: absolute;\n  top: -2px;\n  left: -2px;\n  right: -2px;\n  bottom: -2px;\n  border: 2px solid rgba(73, 193, 244, 0.3);\n  border-radius: 50%;\n  animation: ripple 2s ease-out infinite;\n}\n\n@keyframes ripple {\n  0% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  100% {\n    transform: scale(2);\n    opacity: 0;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
